import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getProjectStatusListAntal, getProjectStatusListbyAfid,setofUpdatedashboardProjekt,decrypt,encrypt
} from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {Grid} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
  const { ProjectStatusList,updatedashboardProjekt} = accountsData;
    const { ProjectStatusAntalList,DashboardOrderFilterOption} = DashBoard;
    return {
        authUser,ProjectStatusAntalList,ProjectStatusList,DashboardOrderFilterOption,updatedashboardProjekt
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProjectStatusListAntal: (Afid,userid,DashboardOrderFilterOption) => dispatch(getProjectStatusListAntal(Afid,userid,DashboardOrderFilterOption)),
        getProjectStatusListbyAfid: (Afid,isFrom) => dispatch(getProjectStatusListbyAfid(Afid,isFrom)),
        setofUpdatedashboardProjekt: () => dispatch(setofUpdatedashboardProjekt()),
        dispatch
    };
}
const useStyles = theme => ({
  root: {
      '&::-webkit-scrollbar': {
          width: '5px'
        },
         
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
         
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#12484B',
          outline: '1px solid transparent'
        }
   },
});

class ProjektTable extends Component {
    state={
        ProjectStatusAntalList:[],
        DashboardDialerFilterOption:isEmpty(this.props.DashboardDialerFilterOption)?[]:this.props.DashboardDialerFilterOption,
        done: false,
        intervaltype:1
      }
      intervalID = null
      componentDidMount=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        this.props.getProjectStatusListbyAfid(Afid)
        axios.get(`kontos/DashBoard/getPSLA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
           if(res.data.success){
                                                    let endata = decrypt(res.data.encryptedData,res.data.iv)
                                                    let ndate = JSON.parse(endata)
          this.setState({ 
            ProjectStatusAntalList:isUndefined(ndate.results)?0:ndate.results.ProjektStatusAntalList,
            intervaltype:this.props.intervaltype
         });
         this.initiateInterval() 
         // this.setState({done: true})    
                                                }
           
         })
       
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
          () => {
            if(this.state.done === true){            
              this.setState({done: false})
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            axios.get(`kontos/DashBoard/getPSLA`,
            { params:encrypt(JSON.stringify({
                Afid:Afid,
                FilterOption:[],
                intervaltype:this.props.intervaltype,
                userid:userid
              }))
            })
            .then(res => {
              if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
this.setState({ 
ProjectStatusAntalList:isUndefined(ndate.results)?0:ndate.results.ProjektStatusAntalList,
intervaltype:this.props.intervaltype
});
this.initiateInterval() 
// this.setState({done: true})    
            }
             })
        }
          },
          180000
      );
       
      }
      componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
      }
      componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardProjekt) === 1){
          axios.get(`kontos/DashBoard/getPSLA`,
          { params:encrypt(JSON.stringify({
              Afid:Afid,
              FilterOption:[],
              intervaltype:this.props.intervaltype,
              userid:userid
            }))
          })
          .then(res => {
            if(res.data.success){
              let endata = decrypt(res.data.encryptedData,res.data.iv)
              let ndate = JSON.parse(endata)
this.setState({ 
ProjectStatusAntalList:isUndefined(ndate.results)?0:ndate.results.ProjektStatusAntalList,
intervaltype:this.props.intervaltype
});
this.initiateInterval() 
// this.setState({done: true})    
          }
           })
          this.props.setofUpdatedashboardProjekt()
        }
         if(!isUndefined(this.props.intervaltype)){
        if(parseInt(this.props.intervaltype) !== parseInt(this.state.intervaltype)){
          axios.get(`kontos/DashBoard/getPSLA`,
          { params:encrypt(JSON.stringify({
              Afid:Afid,
              FilterOption:[],
              intervaltype:this.props.intervaltype,
              userid:userid
            }))
          })
          .then(res => {
            if(res.data.success){
              let endata = decrypt(res.data.encryptedData,res.data.iv)
              let ndate = JSON.parse(endata)
this.setState({ 
ProjectStatusAntalList:isUndefined(ndate.results)?0:ndate.results.ProjektStatusAntalList,
intervaltype:this.props.intervaltype
});
this.initiateInterval() 
// this.setState({done: true})    
          }
           })
        }}
    }
      getStalus=(status,Afid)=>{
        if(isEmpty(this.props.ProjectStatusList)){
        if (status === 2) return <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-info  d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.new"/></p></div>
        if (status === 3) return <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-warning  d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.processed"/></p></div>
        if (status === 4) return <div style={{color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px',background:"#be4d25" }} className=" d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.supplemented"/></p></div>
        if (status === 5) return <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px' }} className="bg-success  d-flex align-items-center my-2 justify-content-center"><p style={{ margin: '2px 10px', fontSize: 20 }}><IntlMessages id="Order.status.Done"/></p></div>
      }
      else{
        
        let Sttsta=this.props.ProjectStatusList.filter(item=>{
          return parseInt(item.Value) === parseInt(status)
        }) 
        return (
          // <div style={{ height: '100%',minWidth:"150px", border: '1px solid transparent', borderRadius: '2px',backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color  }} 
          // className="  d-flex align-items-center my-2 justify-content-center">
          //   <p style={{ margin: '2px 10px', fontSize: 20 }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
          <div style={{ color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 ">
            <div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor:isEmpty(Sttsta)?'#e6e6e6':Sttsta[0].Color, marginRight: '15px' }}></div>
            <p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p>
          </div>
        )

        // if (Sttsta[0].Meta === "Arkiverad") return    <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#FF7272', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === "Utkast") return       <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#F3F3F3', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'Pågående') return     <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#7793F5', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'Kompletteras') return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#FFC895', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'Fakturerbar') return  <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#C377E0', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'HÖG PRIO') return     <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#FF7272', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // if (Sttsta[0].Meta === 'KLAR') return         <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#93F8B3', marginRight: '15px' }}></div><p style={{ fontSize: this.props.psFontSize2 > 1 ? this.props.psFontSize2 : 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
        // else return <div style={{ height: '100%', border: '1px solid transparent', borderRadius: '2px', display: 'flex', alignItems:'center', justifyContent: 'flex-start' }} className="my-2 "><div style={{ height: '15px', width: '15px', borderRadius: '50%', backgroundColor: '#fff', marginRight: '15px' }}></div><p style={{ fontSize: 20, fontWeight: '600', textAlign: 'left' }}>{isEmpty(Sttsta)?<IntlMessages id="Other"/>:Sttsta[0].Meta}</p></div>
      }
      }
    render() {
      const { classes } = this.props;
        return (
            <div className={classes.root} style={{width:'95%',overflowY: "auto",height: "auto"}}>
               
                 {
                 !isEmpty(this.state.ProjectStatusAntalList)?this.state.ProjectStatusAntalList.map((n,index) => {
                      return (
                          <Grid
                          container
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          style={{justifyContent: "space-between"}}
                          > 
                          <Grid item xs={6} >{this.getStalus(n.ProjectStatus,n.Afid)}</Grid>
                          <Grid item style={{color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}><span style={{fontSize: this.props.psFontSize > 1 ? this.props.psFontSize : 35}}>{n.Antal}</span>st</Grid>
                          </Grid>
                      )
                  })
                 :""
                 }   
               
                    
               
    </div>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)(withStyles(useStyles)(ProjektTable));